import React from 'react';
import DefaultLeadsPage from '../../components/LeadsDataWithFilter/index';

function SimpleLeadsPage() {
  return (
    <DefaultLeadsPage leadType="Simple" />
  );
}

export default SimpleLeadsPage;
